import {
  Award,
  BookOpen,
  Calendar,
  DollarSign,
  Flame,
  GraduationCap,
  Image,
  LayoutTemplate,
  MessageCircleQuestion,
  Send,
  Sparkles,
  Star,
  Target,
  Trophy,
  UserPlus,
  Zap,
} from "lucide-react";
import { getAchievementCatalogEntry, resolveAchievementLabel } from "@/lib/achievementCatalog";
import type { AchievementIconName } from "@/lib/achievementCatalog";
import { SparkleCelebration } from "./SparkleCelebration";

const ICONS = {
  Award,
  Flame,
  Star,
  Trophy,
  Zap,
  BookOpen,
  GraduationCap,
  DollarSign,
  Sparkles,
  Calendar,
  LayoutTemplate,
  Image,
  Target,
  MessageCircleQuestion,
  UserPlus,
  Send,
} as const satisfies Record<AchievementIconName, typeof Award>;

export function AchievementBadge(props: {
  achievementKey: string;
  metadata?: Record<string, unknown>;
  /** When true, fires the sparkle overlay one-shot for newly unlocked rows. */
  fresh?: boolean;
}) {
  const def = getAchievementCatalogEntry(props.achievementKey);
  const Icon = ICONS[def.icon] ?? Award;
  const label = resolveAchievementLabel(props.achievementKey, props.metadata);

  return (
    <span className="relative inline-flex items-center gap-1 rounded-full bg-white px-2 py-0.5 text-xs font-medium ring-1 ring-gray-200 shadow-sm dark:bg-zinc-900 dark:ring-zinc-700">
      <Icon className={["h-3.5 w-3.5", def.tint].join(" ")} aria-hidden="true" />
      <span className="text-gray-800 dark:text-gray-100">{label}</span>
      <SparkleCelebration active={!!props.fresh} />
    </span>
  );
}
